// extracted by mini-css-extract-plugin
export default {"profile_icon":"ProfileSidebar_profile_icon__7h-pE","signout_icon":"ProfileSidebar_signout_icon__RK4pU"};